<script setup lang="ts">
import SparkIcon from '@/components/icons/SparkIcon.vue'
import { usePathwayCompletionChallenge } from '@/composables/game/challenges'
import DoubleArrowsUpImage from '@/assets/images/pathway-double-arrows-up.png'

const { countdown, formattedCountdown, isPathwayCompletionChallengeLive } = usePathwayCompletionChallenge()
</script>

<template>
  <div
    v-if="isPathwayCompletionChallengeLive"
    class="flex flex-col items-center justify-center"
  >
    <div class="relative flex items-center justify-center daily-up-button size-12 blue-gradient-background rounded-[15px] p-0.5">
      <SparkIcon
        class="absolute sparkling-star h-4 w-4 z-[10]"
      />
      <img
        class="size-10 object-cover z-[3]"
        :src="DoubleArrowsUpImage"
      >
    </div>
    <div class="z-[10] flex flex-col -mt-2 items-center">
      <div class="z-[1] whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-tropee-black">
        Challenge
      </div>
      <div
        class="z-[2] -mt-1 whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] tabular-nums"
        :class="countdown < (3600 * 3) ? 'text-red-danger' : 'text-tropee-black'"
      >
        {{ formattedCountdown }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.sparkling-star {
	top: 4px;
	right: 4px;
	animation: sparkle 2.5s infinite;
	transition: all;
	transition-delay: 200ms;
}

@keyframes sparkle {
	0% {
		bottom: auto;
		left: auto;
		top: 4px;
		right: 4px;
		opacity: 1;
	}
	20% {
		bottom: auto;
		left: auto;
		top: 4px;
		right: 4px;
		opacity: 0;
	}
	35% {
		top: auto;
		right: auto;
		bottom: 4px;
		left: 4px;
		opacity: 0;
	}
	50% {
		top: auto;
		right: auto;
		bottom: 4px;
		left: 4px;
		opacity: 1;
	}
	70% {
		top: auto;
		right: auto;
		bottom: 4px;
		left: 4px;
		opacity: 0;
	}
	85% {
		bottom: auto;
		left: auto;
		top: 4px;
		right: 4px;
		opacity: 0;
	}
	100% {
		bottom: auto;
		left: auto;
		top: 4px;
		right: 4px;
		opacity: 1;
	}
}

.blue-gradient-background {
	background: linear-gradient(180deg, #EED652 0.01%, #4F59AF 23.08%, #000 36.54%)
}

.red-blur {
	background: #801AC0;
	filter: blur(9px);
}

.daily-up-button::before {
	background: linear-gradient(
		to bottom,
		rgba(255, 255, 255, 0.4) 0%,
		rgba(255, 255, 255, 1) 50%,
		rgba(255, 255, 255, 0.4) 100%
	);
	border-radius: 15px;
	content: "";
	inset: 0;
	-webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
	-webkit-mask-composite: xor;
	mask-composite: exclude;
	padding: 2px; /* this is the border width */
	position: absolute;
	z-index: 10;
	pointer-events: none;
}
</style>